module.exports = __webpack_public_path__ + "img/block_img_1.01b95e5d.jpg";